import React from 'react';

import { AuthProvider } from './Auth/AuthContext';

const AppProvider = ({ children }) => <AuthProvider>{children}</AuthProvider>;

export default AppProvider;
